import { get } from '@/util/auth'

import { API_ROUTE_NOTIFICATIONS } from './apiRoutes'

const IS_NEW_BACKEND_API = true

type NotificationsOriginal = {
  newDeviceOrderAmount: number
  newSubscriptionOrderAmount: number
  newShopOrderAmount: number
  pendingInjuryReportAmount: number
  newOrdersAmount: number
  pendingTradeInOrderActions: number
}

export const notificationResources = {
  get: async () => await get<NotificationsOriginal>(API_ROUTE_NOTIFICATIONS, IS_NEW_BACKEND_API),
}

export type Notifications = Awaited<ReturnType<typeof notificationResources.get>>
